import { openEventFile } from './secureEventFiles';

export function applicationFiles(app) {
  const result = [];
  const planUrl = app?.plan_file ? (app.plan_file_download_url || `/main/api/applications/${app.id}/plan-content/`) : '';
  if (app?.plan_file) result.push({ name: app.plan_file_name || `План помещения${String(app.plan_file).split('?')[0].match(/\.[a-z\d]{1,10}$/i)?.[0] || ''}`, url: planUrl, link: planUrl,
    fromApplication: true, applicationId: app.id, isPlanFile: true, size: 0, mime_type: app.plan_file_mime || '' });
  for (const file of app?.input_files || []) {
    if (!file.file) continue;
    result.push({ id: file.id, name: file.original_name || `Файл ${file.id}`, url: file.file, link: file.file,
      size: file.size || 0, mime_type: file.mime_type || '', fromApplication: true, applicationId: app.id });
  }
  return result;
}

export function previewApplicationFile(file) {
  if (file instanceof Blob) {
    const url = URL.createObjectURL(file);
    const inline = /^(application\/pdf|image\/(png|jpeg|gif|webp|avif|bmp))$/i.test(file.type || '');
    let tab;
    if (inline) tab = window.open(url, '_blank', 'noopener,noreferrer');
    else {
      const anchor = document.createElement('a');
      anchor.href = url; anchor.download = file.name || 'Файл';
      document.body.appendChild(anchor); anchor.click(); anchor.remove();
    }
    setTimeout(() => URL.revokeObjectURL(url), 10 * 60 * 1000);
    return Promise.resolve(tab);
  }
  return openEventFile({ ...file, name: file.name || file.original_name || 'Файл',
    link: file.file || file.link || file.url });
}
